<div id="comparatoreMFHeader" class="header-comparatore-mf">

  <div class="row justify-content-between align-items-center py-1">

    <div class="col-sm-2 text-start">
      <a href="https://www.milanofinanza.it/" target="_blank"  aria-label="Milano Finanza">
        <img
          *ngIf="getScreenWidth"
          width="138"
          height="45"
          alt="Milano Finanza"
          src=".\assets\imgs\MF_logo.png"
          class="header-logos"
          loading="lazy"
        />
      </a>
    </div>

    <div class="col-sm-8 img-header-container">
      <a href="/" aria-label="Comparatore Polizze Vita">
        <img
          *ngIf="getScreenWidth"
          width="400"
          height="80"
          src=".\assets\imgs\logo-mf-polizze-vita.png"
          alt="Comparatore Polizze Vita"
          class="img-header"
          loading="lazy"
        />
      </a>
    </div>

    <div class="col-sm-2 text-end">
      <a href="https://www.fidaonline.com" target="_blank" aria-label="FIDA Finanza Dati Analisi">
        <img
          *ngIf="getScreenWidth"
          width="138"
          height="45"
          src=".\assets\imgs\Fida_logo_DT.png"
          alt="FIDA Finanza Dati Analisi"
          class="header-logos"
          loading="lazy"
        />
      </a>
    </div>
  </div>

  <div class="sub-header">

    <div class="sub-header-btns-container">

      <div class="dropdown menu-item-mobile">
        <button class="p-2 link-menu menu-item-button" type="button" data-bs-toggle="dropdown" aria-expanded="false" aria-label="dropdown menu toggle">
          <i class="fa-solid fa-bars"></i>
        </button>
        <div class="dropdown-menu">
          <button class="dropdown-item" (click)="goToLink('/glossario')"><span><i class="fa-solid fa-book me-1"></i> Glossario</span></button>
          <button class="dropdown-item" (click)="loadSavedSurveys()"><span><i class="fa-solid fa-list"></i> My Searches</span></button>
          <button class="dropdown-item" (click)="loadFavorites()"><span><i class="fa-solid fa-star"></i> My Products</span></button>
          <!-- <button class="dropdown-header" *ngIf="isAuthenticated"><span><i class="fa-solid fa-user"></i> User Info</span></button> -->
          <li class="dropdown-item"><span><i class="fa-solid fa-user"></i> User Info</span></li>
          <button class="dropdown-item" (click)="goToLinkExt(domain+'/Identity/Account/Manage')"><span class="menu-item-padding-left">Dati personali</span></button>
          <button class="dropdown-item" (click)="goToLinkExt(domain+'/Identity/Account/Manage/ChangePassword')"><span class="menu-item-padding-left">Modifica la password</span></button>
          <button class="dropdown-item" *ngIf="isAuthenticated" (click)="logoffAndRevokeTokens()"><span>Logout</span></button>
          <button class="dropdown-item" *ngIf="!isAuthenticated" (click)="login()"><span><i class="fa-solid fa-right-to-bracket"></i> Login</span></button>
        </div>
      </div>

      <a class="p-2 link-menu" routerLink="/"><i class="fa-solid fa-house"></i> Home</a>
      <a class="p-2 link-menu menu-item-desktop" routerLink="/glossario"><i class="fa-solid fa-book me-1"></i> Glossario</a>
    </div>

    <div class="header-login-btns">

      <button class="p-2 link-menu menu-item-desktop menu-item-button" (click)="loadSavedSurveys()"><i class="fa-solid fa-list"></i> My Searches</button>
      <button class="p-2 link-menu menu-item-desktop menu-item-button" (click)="loadFavorites()"><i class="fa-solid fa-star"></i> My Products</button>

      <div class="dropdown menu-item-desktop">
        <button class="dropdown-toggle p-2 link-menu menu-item-button" *ngIf="isAuthenticated"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa-solid fa-user"></i> User Info
        </button>
        <div class="dropdown-menu">
          <button class="dropdown-item" (click)="goToLinkExt(domain+'/Identity/Account/Manage')">Dati personali</button>
          <button class="dropdown-item" (click)="goToLinkExt(domain+'/Identity/Account/Manage/ChangePassword')">Modifica la password</button>
        </div>
      </div>

      <button class="p-2 link-menu menu-item-button" *ngIf="isAuthenticated" (click)="logoffAndRevokeTokens()">Logout</button>
      <button class="p-2 link-menu menu-item-button" *ngIf="!isAuthenticated" (click)="login()"><i class="fa-solid fa-right-to-bracket"></i> Login</button>

    </div>
  </div>


  <lib-overlay-loading [isLoading]="isLoading" [isShowSpinner]="true" progressMode="indeterminate"></lib-overlay-loading>

<div>
